define('views/components/distributor_role/distributor_role',['require','backbone','text!templates/components/distributor_role/distributor_role.html'],function(require){

    var Backbone = require('backbone');

    var temp = require("text!templates/components/distributor_role/distributor_role.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'tr',
        template: _.template(temp),
        className: 'distributor-role-item'
    });
});
